<template>
  <div>
    <!-- 留言板 -->
    <Board :index="1"></Board>
  </div>
</template>
<script>
import Board from '../components/Board';
export default {
  components: { Board },
};
</script>


// WEBPACK FOOTER //
// src/pages/MessageBoard.vue